import React from 'react'
import Header from '../../molecules/Header/Header'
import SupportEmailModal from '../../organisms/SupportEmail/SupportEmailModal'

const ProcessPage = ({ linkPrefix, titleNewProcess, contentComponent, hideNewProcess = false }) => {
  return (
    <>
      <Header linkPrefix={linkPrefix} titleNewProcess={titleNewProcess} hideNewProcess={hideNewProcess} />
      <SupportEmailModal />
      {contentComponent}
    </>
  )
}

export default ProcessPage
